import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "className"];
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { forwardRef, useContext } from 'react';
import { PopoverOverflowContext } from './popover-overflow-context.js';
import styles from './popover.module.js';
/**
 * Container to hold the footer content for the popover
 */

var PopoverFooter = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var children = props.children,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  var _useContext = useContext(PopoverOverflowContext),
      isContentOverflowing = _useContext.isContentOverflowing;

  return jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
    ref: forwardedRef,
    className: clsx(styles.popoverFooter, className, // apply top border when main content is overflowing
    isContentOverflowing ? styles.popoverFooterTopBorder : ''),
    children: children
  }));
});
PopoverFooter.displayName = 'PopoverFooter';
export { PopoverFooter };